import { render, staticRenderFns } from "./SnapchatForms.vue?vue&type=template&id=173b2a52&scoped=true&"
import script from "./SnapchatForms.vue?vue&type=script&lang=js&"
export * from "./SnapchatForms.vue?vue&type=script&lang=js&"
import style0 from "./SnapchatForms.vue?vue&type=style&index=0&id=173b2a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173b2a52",
  null
  
)

export default component.exports